import { ThunkAction } from "action/ThunkAction";

import { getStripeDashboardUrl as getStripeDashboardUrlApi } from "./api";

export function getStripeDashboardUrl(): ThunkAction {
  return async (dispatch, _, { fetchV2 }) => {
    return await fetchV2(getStripeDashboardUrlApi());
  };
}
